export default __webpack_public_path__ + "static/moonpay_splash-c846a713684cd1ef5ac5e56e531f596e.png";